export enum EQuotationEntryPoints {
    cost = 'cost',
    retail = 'retail',
    included = 'included',
    option = 'option',
}
